import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/accordion';
import { faqs } from '../mock';

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-violet-700/8 blur-[130px] pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-violet-300/70 uppercase mb-5">
            <span className="h-px w-10 bg-violet-400/50" />
            <span>FAQ</span>
            <span className="h-px w-10 bg-violet-400/50" />
          </div>
          <h2 className="font-display text-6xl md:text-7xl leading-[0.9]">
            <span className="text-white">GOT </span>
            <span className="text-gradient-purple italic">QUESTIONS?</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f) => (
            <AccordionItem
              key={f.q}
              value={f.q}
              className="border border-violet-500/15 rounded-md bg-gradient-to-b from-violet-950/20 to-transparent px-6 data-[state=open]:border-violet-400/40"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5">
                <span className="font-medium text-white/90 text-base md:text-lg pr-4">{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-[15px] leading-relaxed pb-5 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
